import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { GuardLoadingService } from '../../services/guard-loading.service';

@Component({
  selector: 'app-guard-loading-indicator',
  imports: [],
  templateUrl: './guard-loading-indicator.component.html',
  styleUrls: ['./guard-loading-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuardLoadingIndicatorComponent {
  private readonly loadingService = inject(GuardLoadingService);

  readonly isLoading = this.loadingService.isLoading;
  readonly activeCount = this.loadingService.activeCount;

  readonly displayText = computed(() => {
    const count = this.activeCount();
    return count === 1 ? 'Loading...' : `Loading ${count} items...`;
  });
}